import { Link } from 'react-router-dom';

const LOGO_ON_DARK = `${process.env.PUBLIC_URL}/images/sbr2th-logo.png`;
const LOGO_ON_LIGHT = `${process.env.PUBLIC_URL}/images/sbr2th-logo-dark.png`;

type Props = {
  /** `light` = white logo on dark backgrounds (navbar, footer). `dark` = black logo on light backgrounds. */
  variant?: 'light' | 'dark';
  className?: string;
  /** Max height in px for the logo image. */
  maxHeight?: number;
};

export default function BrandLogo({ variant = 'dark', className, maxHeight = 40 }: Props) {
  const src = variant === 'light' ? LOGO_ON_DARK : LOGO_ON_LIGHT;

  return (
    <Link to="/" className={`navbar-brand d-inline-flex align-items-center py-0 ${className ?? ''}`}>
      <img
        src={src}
        alt="SBR2TH"
        width={361}
        height={201}
        decoding="async"
        style={{ maxHeight, width: 'auto', height: 'auto' }}
      />
    </Link>
  );
}
